"use client";

import { c as _c } from "react/compiler-runtime";
import { useDebounceFn } from "ahooks";
import { usePathname } from "next/navigation";
import HeartIcon from "@/assets/svg/heart-line.svg";
import { authClient } from "@/lib/auth/auth-client";
import { useLocaleRouter } from "@/lib/utils.client";
export function WishButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <WishWrapper><HeartIcon className="size-5.5 md:w-[20px] md:h-[20px]" style={{
        cursor: "pointer"
      }} /></WishWrapper>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function WishWrapper(t0) {
  const $ = _c(10);
  const {
    children,
    onSamePathClick
  } = t0;
  const router = useLocaleRouter();
  const pathname = usePathname();
  const {
    data: session,
    isPending: isSessionPending
  } = authClient.useSession();
  const userProfile = session?.user;
  let t1;
  if ($[0] !== isSessionPending || $[1] !== onSamePathClick || $[2] !== pathname || $[3] !== router || $[4] !== userProfile) {
    t1 = () => {
      if (isSessionPending) {
        return;
      }
      if (!userProfile || userProfile.isAnonymous) {
        onSamePathClick?.();
        router.replace("/user/login?redirect=/user/wish-list");
        return;
      }
      if (pathname === "/user/wish-list") {
        onSamePathClick?.();
        return;
      }
      onSamePathClick?.();
      router.push("/user/wish-list");
    };
    $[0] = isSessionPending;
    $[1] = onSamePathClick;
    $[2] = pathname;
    $[3] = router;
    $[4] = userProfile;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleClick = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      leading: true
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    run
  } = useDebounceFn(handleClick, t2);
  let t3;
  if ($[7] !== children || $[8] !== run) {
    t3 = <span onClick={run}>{children}</span>;
    $[7] = children;
    $[8] = run;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}